import { useLocation, matchPath } from "react-router-dom";
import { useMemo } from "react";

export default function useBreadcrumbsFromConfig(config) {
    const { pathname } = useLocation();

    const byPath = useMemo(() => {
        const m = new Map();
        config.forEach((r) => m.set(r.path, r));
        return m;
    }, [config]);

    const currentMatch = useMemo(() => {
        let best = null;
        for (const route of config) {
            const m = matchPath({ path: route.path, end: true }, pathname);
            if (m) {
                if (!best || route.path.length > best.route.path.length) {
                    best = { route, match: m };
                }
            }
        }
        return best;
    }, [config, pathname]);

    if (!currentMatch) return [];

    const chain = [];
    let node = currentMatch.route;
    let params = currentMatch.match.params;

    while (node) {
        chain.push({ route: node, params });
        node = node.parent ? byPath.get(node.parent) : null;
    }

    chain.reverse();

    const items = chain.map(({ route, params }, idx) => {
        const isCurrent = idx === chain.length - 1;
        const label =
            typeof route.breadcrumb === "function"
                ? route.breadcrumb({ params })
                : route.breadcrumb || route.path;

        return { path: route.path, label, isCurrent };
    });

    return items;
}
